import { Alert } from 'antd';
import React from 'react';
import { useLogin } from 'utils/hooks/useLogin';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoginForm from './components/LoginForm';

import styles from './styles.module.css';

const { UserName, Password, Submit } = LoginForm;

const LoginMessage = ({ content }) => <Alert style={{ marginBottom: 24 }} message={content} type="error" showIcon />;
LoginMessage.propTypes = {
  content: PropTypes.string,
};

const Login = () => {
  const { loginUser, submitting, error } = useLogin();
  const handleSubmit = (values) => {
    loginUser(values);
  };

  return (
    <div className={styles.main}>
      <LoginForm onSubmit={handleSubmit}>
        {error && !submitting && <LoginMessage content="Wrong username or password" />}
        <UserName
          name="username"
          placeholder="ユーザー名"
          rules={[
            {
              required: true,
            },
          ]}
        />
        <Password
          name="password"
          placeholder="パスワード"
          rules={[
            {
              required: true,
            },
          ]}
        />
        <div className={styles.pullRight}>
          <Link to="/password/forgot">パスワードをお忘れの場合</Link>
        </div>
        <Submit loading={submitting}>ログイン</Submit>
      </LoginForm>
    </div>
  );
};

export default Login;
